import React from "react";
import DesktopMenu from "./desktop-menu";
import ProfileMenu from "./profile-menu";
import NotificationMenu from "./notification-menu";
import { useSelector } from "react-redux";
import { getLoggedinUser } from "@/store/slices/auth/authSlice";
import useFrontdoorNotifications from "@/hooks/useFrontdoorNotifications";

const initialAnchoEl = { profile: null, notifications: null };

const RightNavSection = ({ handleTheme }) => {
  // const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchorEl, setAnchorEl] = React.useState(initialAnchoEl);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);
  const user = useSelector(getLoggedinUser);
  const {} = useFrontdoorNotifications({
    desktopNotification: true,
  });

  const isProfileMenuOpen = Boolean(anchorEl["profile"]);
  const isNotificationMenuOpen = Boolean(anchorEl["notifications"]);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  const handleMenuOpen = (event, type) => {
    let name = event?.currentTarget?.name || type;
    // setAnchorEl((prev) => ({ ...prev, [name]: event.currentTarget }));
    let tempAnchorEL = { ...anchorEl };
    tempAnchorEL[name] = event?.currentTarget;
    setAnchorEl({ ...tempAnchorEL });
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(initialAnchoEl);
    handleMobileMenuClose();
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  return (
    <>
      <DesktopMenu
        handleMenuOpen={handleMenuOpen}
        displayName={user?.DisplayName}
      />

      {/* <MobileMenu
        isMenuOpen={isMobileMenuOpen}
        mobileMoreAnchorEl={mobileMoreAnchorEl}
        handleMobileMenuOpen={handleMobileMenuOpen}
        handleMobileMenuClose={handleMobileMenuClose}
        handleMenuOpen={handleMenuOpen}
      /> */}

      <ProfileMenu
        anchorEl={anchorEl["profile"]}
        isMenuOpen={isProfileMenuOpen}
        handleMenuClose={handleMenuClose}
        handleTheme={handleTheme}
      />

      <NotificationMenu
        anchorEl={anchorEl["notifications"]}
        isMenuOpen={isNotificationMenuOpen}
        handleMenuClose={handleMenuClose}
      />
    </>
  );
};

export default RightNavSection;
